module.exports = __webpack_public_path__ + "img/authenticationBlue.fd35feb6.png";